import React from 'react';
import ContainerDefault from '../Container';

export interface ExplanationProperties {
    head: string;
    text: string;
    bullets?: string[];
}

interface ExplanationProps {
    help: ExplanationProperties | undefined;
}

const ExplanationContainer = ContainerDefault.extend`
    position: absolute;
    top: 0;
    right: -19em;
    width: 17em;
`;

const Explanation: React.FC<ExplanationProps> = props => {
    if (props.help) {
        return (
            <ExplanationContainer>
                <h3>{props.help.head}</h3>
                <p>{props.help.text}</p>
                {props.help.bullets && (
                    <ul>
                        {props.help.bullets.map((bullet, index) => (
                            <li key={index}>{bullet}</li>
                        ))}
                    </ul>
                )}
            </ExplanationContainer>
        );
    } else {
        return null;
    }
};

export default Explanation;



// WEBPACK FOOTER //
// ./src/components/cognito/Explanation.tsx